import { WorkingDaysModel } from "client/Api/UserProfile/service";
import { ReactElement, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { WorkingDays } from "client/Features/PersonalInformationPage/WorkingDays";
import { Section, SectionEmptyBehavior } from "./Section";

export type WorkingDaysSectionProps = {
	workingDays: WorkingDaysModel | null;
	emptyBehavior: SectionEmptyBehavior;
};

export const WorkingDaysSection = (props: WorkingDaysSectionProps): ReactElement => {
	const {
		emptyBehavior
	} = props;

	const workingDays: WorkingDaysModel = props.workingDays
		?? UNSET_WORKING_DAYS;

	const isEmpty = useMemo(
		(): boolean => {
			const {
				monday,
				tuesday,
				wednesday,
				thursday,
				friday,
				saturday,
				sunday
			} = workingDays;

			return [
				monday,
				tuesday,
				wednesday,
				thursday,
				friday,
				saturday,
				sunday
			]
				.every(x => !x);
		},
		[workingDays]
	);

	return (
		<Section
			title={localize("_WorkingDays")}
			trackingId="working-days"
			emptyBehavior={emptyBehavior}
			isEmpty={isEmpty}
		>
			<WorkingDays
				data={workingDays}
				format="full"
				trackingId="tags"
				color="success"
			/>
		</Section>
	);
};
WorkingDaysSection.displayName = "WorkingDaysSection";

const UNSET_WORKING_DAYS: WorkingDaysModel = {
	monday: false,
	tuesday: false,
	wednesday: false,
	thursday: false,
	friday: false,
	saturday: false,
	sunday: false
};